import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ConstantField } from '@/constant/ConstantField';
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { Action, WithOptionalRest } from '@/typeDefine/CommonTypes';
import { CarouselType } from '@/typeDefine/EntityType';
import { CarouselList } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { onMounted, onUnmounted, ref, Ref } from 'vue'

const swiperInitHeight: number = 600

//轮播图高度

export default /*@__PURE__*/_defineComponent({
  __name: 'Swiper',
  emits: ["viewport"],
  setup(__props, { emit: __emit }) {

const carouselRef: Ref<HTMLElement | null> = ref(null)

//轮播图初始高度
const swiperHeight: Ref<number> = ref(swiperInitHeight)

//轮播列表
const carouselList: Ref<CarouselList['data']['carousel']> = ref([])

//检测轮播视口监听器
let observer: IntersectionObserver

const emit = __emit

onMounted(() => {
    getCarousel()
    changeSwiperHeight()
    watchCarouselViewport()
    window.addEventListener('resize', changeSwiperHeight)
})

const watchCarouselViewport: Action = () => {

    observer = new IntersectionObserver(
        (entries) => {
            const entry = entries[0]
            
            //发送视口事件
            emit('viewport',entry.isIntersecting)
        },
        {
            root: null, // 视口
            threshold: 0.1 // 只要有一点进入视口就算可见
        }
    )

    if (carouselRef.value) {
        observer.observe(carouselRef.value)
    }
}

//动态改变轮播高度
const changeSwiperHeight: Action = () => {
    const width: number = window.innerWidth

    if (width <= 1000 && width > 768) {
        swiperHeight.value = 300
        return
    }

    if (width <= 768) {
        swiperHeight.value = 200
        return
    }

    swiperHeight.value = swiperInitHeight
}

//获取轮播图列表
const getCarousel: Action = async () => {

    const response: CarouselList = await Api.instance.getAllCarousel()

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        carouselList.value = response.data.carousel
        carouselList.value.map(item => item.path = `${item.path}`)
    }
}

onUnmounted(() => {
    window.removeEventListener('resize', changeSwiperHeight)
})


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", {
    class: "swiper-content",
    ref_key: "carouselRef",
    ref: carouselRef
  }, [
    _createVNode(_component_el_carousel, {
      height: swiperHeight.value + 'px',
      "indicator-position": "outside"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselList.value, (item) => {
          return (_openBlock(), _createBlock(_component_el_carousel_item, {
            key: item.id
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_image, {
                src: item.path,
                style: {"width":"100%","height":"100%"}
              }, null, 8, ["src"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["height"])
  ], 512))
}
}

})